export function reduceToMap<T extends { id: number }>(entries: T[]): Record<number, T> {
  return entries.reduce(
    (result, entry) => {
      result[entry.id] = entry;
      return result;
    },
    {} as Record<number, T>,
  );
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseAsArray(raw: any): any[] {
  if (raw instanceof Array) {
    return raw;
  }
  return [raw];
}
export function parseVec3DArray(raw: string): [number, number, number][] {
  return raw.split(',').map((vec) => {
    const components = vec.split(' ').map(Number);
    return [components[0], components[1], components[2]];
  });
}

export function findKeyBefore(keys: string[], key: string, ifFirst = 'none') {
  const index = keys.indexOf(key);
  if (index === 0 || keys.length === 1) {
    return ifFirst;
  }
  return keys[index - 1];
}
